// 現場スタッフ専用画面の5言語対応（ja / pt-BR / en / vi / id）
export const LANG_OPTIONS = [
  { code: "ja", label: "日本語" },
  { code: "pt-BR", label: "Português" },
  { code: "en", label: "English" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "id", label: "Indonesia" },
];

const T = {
  ja: {
    app_name: "ネオ建設 スタッフ画面",
    login_title: "スタッフ ログイン",
    login_id: "ログインID",
    password: "パスワード",
    sign_in: "ログイン",
    login_failed: "ログインIDまたはパスワードが正しくありません",
    logout: "ログアウト",
    home: "ホーム",
    schedule: "予定",
    photos: "写真",
    today: "今日の予定",
    tomorrow: "明日の予定",
    notifications: "お知らせ",
    no_plans: "予定はありません",
    no_notifications: "お知らせはありません",
    meeting: "集合",
    site_address: "現場住所",
    safety: "安全上の注意",
    work_content: "作業内容",
    instructions: "作業指示",
    tools_to_bring: "工具・持ち物",
    month_schedule: "月間予定",
    upload_photo: "写真を登録",
    select_project: "工事案件を選択",
    select_site: "現場を選択",
    select_schedule: "作業予定を選択（任意）",
    category: "写真分類",
    cat_before: "施工前",
    cat_during: "施工中",
    cat_after: "施工後",
    title_label: "タイトル",
    description: "説明（母国語で入力できます）",
    take_or_choose: "写真を撮る / 選ぶ",
    submit: "登録する",
    uploading: "送信中...",
    uploaded_ok: "写真を登録しました",
    upload_failed: "登録に失敗しました",
    my_photos: "登録した写真",
    status_label: "状態",
    st_pending: "未確認",
    st_approved: "承認",
    st_rejected: "差戻し",
    type_work: "作業",
    type_off: "休日",
    type_leave: "休暇",
    report_title: "作業報告",
    actual_start: "実際の開始時刻",
    actual_end: "実際の終了時刻",
    report_note: "報告・メモ",
    done_label: "完了した",
    send_report: "報告を送信",
    report_sent: "報告しました",
    language: "言語",
    new_schedule: "新しい作業予定",
    changed_schedule: "予定の変更",
    cancelled_schedule: "予定の中止",
    all_day: "終日",
    required_count: "必要人数",
    people: "名",
    nav_report: "日報",
    report_new: "日報を書く",
    hours_label: "実働時間",
    report_saved: "日報を保存しました",
    my_reports: "日報の履歴",
    no_reports: "日報はまだありません",
    date_label: "日付",
    nav_survey: "調査",
    survey_title: "現地調査",
    survey_none: "担当の案件はありません",
    shot_guide: "撮影指示（タップで撮影）",
    shot_none: "撮影指示はまだありません。下の「その他の写真」から登録できます。",
    shot_tap: "タップしてカメラで撮影",
    shot_taken: "撮影済み",
    shot_again: "追加で撮る",
    shot_required: "必須",
    extra_photo: "その他の写真",
    survey_result: "調査結果を記録",
    survey_note_ph: "現地の状況・寸法・注意点・見積に含める内容など",
    survey_submit: "調査結果を送信",
    survey_saved: "調査結果を送信しました",
    survey_missing: "未撮影の必須写真",
    survey_recorded: "記録済み",
    plan_hint: "番号を押すとカメラが開きます。番号の位置に立ち、矢印の向きに撮ってください。緑＝撮影済み",
    plan_direction: "平面図の番号の位置に立ち、矢印の方向にカメラを向けて撮影してください。",
    plan_shoot: "カメラで撮影",
    dir_0: "北",
    dir_1: "北東",
    dir_2: "東",
    dir_3: "南東",
    dir_4: "南",
    dir_5: "南西",
    dir_6: "西",
    dir_7: "北西",
    facing: "カメラの向き",
    guide_arrived: "撮影指示が届きました",
    video_tap: "タップして動画を撮影（60秒まで）",
    video_too_long: "動画は60秒までです。短く撮り直してください。",
  },
  en: {
    app_name: "NEO Construction Staff",
    login_title: "Staff Login",
    login_id: "Login ID",
    password: "Password",
    sign_in: "Sign in",
    login_failed: "Invalid login ID or password",
    logout: "Log out",
    home: "Home",
    schedule: "Schedule",
    photos: "Photos",
    today: "Today",
    tomorrow: "Tomorrow",
    notifications: "Notifications",
    no_plans: "No plans",
    no_notifications: "No notifications",
    meeting: "Meet at",
    site_address: "Site address",
    safety: "Safety notes",
    work_content: "Work details",
    instructions: "Instructions",
    tools_to_bring: "Tools / items",
    month_schedule: "Monthly schedule",
    upload_photo: "Upload photo",
    select_project: "Select project",
    select_site: "Select site",
    select_schedule: "Select plan (optional)",
    category: "Category",
    cat_before: "Before",
    cat_during: "During",
    cat_after: "After",
    title_label: "Title",
    description: "Description (your language is OK)",
    take_or_choose: "Take / choose photo",
    submit: "Submit",
    uploading: "Uploading...",
    uploaded_ok: "Photo uploaded",
    upload_failed: "Upload failed",
    my_photos: "My photos",
    status_label: "Status",
    st_pending: "Pending",
    st_approved: "Approved",
    st_rejected: "Returned",
    type_work: "Work",
    type_off: "Day off",
    type_leave: "Leave",
    report_title: "Work report",
    actual_start: "Actual start",
    actual_end: "Actual end",
    report_note: "Report / note",
    done_label: "Completed",
    send_report: "Send report",
    report_sent: "Report sent",
    language: "Language",
    new_schedule: "New work plan",
    changed_schedule: "Plan changed",
    cancelled_schedule: "Plan cancelled",
    all_day: "All day",
    required_count: "Workers needed",
    people: "",
    nav_report: "Report",
    report_new: "Write daily report",
    hours_label: "Hours worked",
    report_saved: "Report saved",
    my_reports: "My reports",
    no_reports: "No reports yet",
    date_label: "Date",
    nav_survey: "Survey",
    survey_title: "Site survey",
    survey_none: "No assigned projects",
    shot_guide: "Photo instructions (tap to shoot)",
    shot_none: "No photo instructions yet. Use \"Other photo\" below.",
    shot_tap: "Tap to open the camera",
    shot_taken: "Taken",
    shot_again: "take more",
    shot_required: "Required",
    extra_photo: "Other photo",
    survey_result: "Record survey result",
    survey_note_ph: "Site condition, sizes, cautions, items for the estimate",
    survey_submit: "Send survey result",
    survey_saved: "Survey result sent",
    survey_missing: "Required photos not taken",
    survey_recorded: "Recorded",
    plan_hint: "Tap a number to open the camera. Stand at the number and shoot in the arrow direction. Green = done",
    plan_direction: "Stand at the numbered spot on the plan and point the camera in the arrow direction.",
    plan_shoot: "Open camera",
    dir_0: "North",
    dir_1: "Northeast",
    dir_2: "East",
    dir_3: "Southeast",
    dir_4: "South",
    dir_5: "Southwest",
    dir_6: "West",
    dir_7: "Northwest",
    facing: "Camera faces",
    guide_arrived: "Photo instructions received",
    video_tap: "Tap to record a video (up to 60 s)",
    video_too_long: "Videos can be up to 60 seconds. Please record a shorter one.",
  },
  "pt-BR": {
    app_name: "NEO Construção Equipe",
    login_title: "Login da equipe",
    login_id: "ID de login",
    password: "Senha",
    sign_in: "Entrar",
    login_failed: "ID ou senha incorretos",
    logout: "Sair",
    home: "Início",
    schedule: "Agenda",
    photos: "Fotos",
    today: "Hoje",
    tomorrow: "Amanhã",
    notifications: "Avisos",
    no_plans: "Sem planos",
    no_notifications: "Sem avisos",
    meeting: "Encontro",
    site_address: "Endereço da obra",
    safety: "Segurança",
    work_content: "Conteúdo do trabalho",
    instructions: "Instruções",
    tools_to_bring: "Ferramentas",
    month_schedule: "Agenda do mês",
    upload_photo: "Enviar foto",
    select_project: "Selecionar obra",
    select_site: "Selecionar local",
    select_schedule: "Selecionar plano (opcional)",
    category: "Categoria",
    cat_before: "Antes",
    cat_during: "Durante",
    cat_after: "Depois",
    title_label: "Título",
    description: "Descrição (pode ser no seu idioma)",
    take_or_choose: "Tirar / escolher foto",
    submit: "Enviar",
    uploading: "Enviando...",
    uploaded_ok: "Foto enviada",
    upload_failed: "Falha no envio",
    my_photos: "Minhas fotos",
    status_label: "Estado",
    st_pending: "Pendente",
    st_approved: "Aprovada",
    st_rejected: "Devolvida",
    type_work: "Trabalho",
    type_off: "Folga",
    type_leave: "Férias",
    report_title: "Relatório de trabalho",
    actual_start: "Início real",
    actual_end: "Término real",
    report_note: "Relatório / nota",
    done_label: "Concluído",
    send_report: "Enviar relatório",
    report_sent: "Relatório enviado",
    language: "Idioma",
    new_schedule: "Novo plano de trabalho",
    changed_schedule: "Plano alterado",
    cancelled_schedule: "Plano cancelado",
    all_day: "Dia inteiro",
    required_count: "Pessoas necessárias",
    people: "",
    nav_report: "Relatório",
    report_new: "Escrever relatório",
    hours_label: "Horas trabalhadas",
    report_saved: "Relatório salvo",
    my_reports: "Meus relatórios",
    no_reports: "Sem relatórios",
    date_label: "Data",
    nav_survey: "Vistoria",
    survey_title: "Vistoria do local",
    survey_none: "Nenhuma obra atribuída",
    shot_guide: "Instruções de foto (toque para fotografar)",
    shot_none: "Ainda sem instruções. Use \"Outra foto\" abaixo.",
    shot_tap: "Toque para abrir a câmera",
    shot_taken: "Fotografado",
    shot_again: "tirar mais",
    shot_required: "Obrigatório",
    extra_photo: "Outra foto",
    survey_result: "Registrar resultado da vistoria",
    survey_note_ph: "Situação do local, medidas, cuidados, itens do orçamento",
    survey_submit: "Enviar resultado",
    survey_saved: "Resultado enviado",
    survey_missing: "Fotos obrigatórias pendentes",
    survey_recorded: "Registrado",
    plan_hint: "Toque no número para abrir a câmera. Fique no ponto e fotografe na direção da seta. Verde = feito",
    plan_direction: "Fique no ponto numerado da planta e aponte a câmera na direção da seta.",
    plan_shoot: "Abrir câmera",
    dir_0: "Norte",
    dir_1: "Nordeste",
    dir_2: "Leste",
    dir_3: "Sudeste",
    dir_4: "Sul",
    dir_5: "Sudoeste",
    dir_6: "Oeste",
    dir_7: "Noroeste",
    facing: "Direção da câmera",
    guide_arrived: "Instruções de foto recebidas",
    video_tap: "Toque para gravar um vídeo (até 60 s)",
    video_too_long: "O vídeo pode ter no máximo 60 segundos. Grave novamente mais curto.",
  },
  vi: {
    app_name: "NEO Construction Nhân viên",
    login_title: "Đăng nhập nhân viên",
    login_id: "ID đăng nhập",
    password: "Mật khẩu",
    sign_in: "Đăng nhập",
    login_failed: "ID hoặc mật khẩu không đúng",
    logout: "Đăng xuất",
    home: "Trang chủ",
    schedule: "Lịch",
    photos: "Ảnh",
    today: "Hôm nay",
    tomorrow: "Ngày mai",
    notifications: "Thông báo",
    no_plans: "Không có lịch",
    no_notifications: "Không có thông báo",
    meeting: "Tập trung",
    site_address: "Địa chỉ công trường",
    safety: "An toàn",
    work_content: "Nội dung công việc",
    instructions: "Chỉ thị",
    tools_to_bring: "Dụng cụ",
    month_schedule: "Lịch tháng",
    upload_photo: "Đăng ảnh",
    select_project: "Chọn công trình",
    select_site: "Chọn công trường",
    select_schedule: "Chọn lịch (tùy chọn)",
    category: "Phân loại",
    cat_before: "Trước thi công",
    cat_during: "Đang thi công",
    cat_after: "Sau thi công",
    title_label: "Tiêu đề",
    description: "Mô tả (có thể nhập bằng tiếng Việt)",
    take_or_choose: "Chụp / chọn ảnh",
    submit: "Đăng",
    uploading: "Đang gửi...",
    uploaded_ok: "Đã đăng ảnh",
    upload_failed: "Đăng thất bại",
    my_photos: "Ảnh của tôi",
    status_label: "Trạng thái",
    st_pending: "Chưa xác nhận",
    st_approved: "Đã duyệt",
    st_rejected: "Trả lại",
    type_work: "Làm việc",
    type_off: "Ngày nghỉ",
    type_leave: "Nghỉ phép",
    report_title: "Báo cáo công việc",
    actual_start: "Bắt đầu thực tế",
    actual_end: "Kết thúc thực tế",
    report_note: "Báo cáo / ghi chú",
    done_label: "Đã hoàn thành",
    send_report: "Gửi báo cáo",
    report_sent: "Đã gửi báo cáo",
    language: "Ngôn ngữ",
    new_schedule: "Lịch làm việc mới",
    changed_schedule: "Lịch đã thay đổi",
    cancelled_schedule: "Lịch đã hủy",
    all_day: "Cả ngày",
    required_count: "Số người cần",
    people: "người",
    nav_report: "Báo cáo",
    report_new: "Viết báo cáo",
    hours_label: "Số giờ làm",
    report_saved: "Đã lưu báo cáo",
    my_reports: "Báo cáo của tôi",
    no_reports: "Chưa có báo cáo",
    date_label: "Ngày",
    nav_survey: "Khảo sát",
    survey_title: "Khảo sát hiện trường",
    survey_none: "Không có công trình được giao",
    shot_guide: "Hướng dẫn chụp ảnh (chạm để chụp)",
    shot_none: "Chưa có hướng dẫn. Dùng \"Ảnh khác\" bên dưới.",
    shot_tap: "Chạm để mở máy ảnh",
    shot_taken: "Đã chụp",
    shot_again: "chụp thêm",
    shot_required: "Bắt buộc",
    extra_photo: "Ảnh khác",
    survey_result: "Ghi kết quả khảo sát",
    survey_note_ph: "Tình trạng, kích thước, lưu ý, nội dung báo giá",
    survey_submit: "Gửi kết quả khảo sát",
    survey_saved: "Đã gửi kết quả khảo sát",
    survey_missing: "Ảnh bắt buộc chưa chụp",
    survey_recorded: "Đã ghi",
    plan_hint: "Chạm số để mở máy ảnh. Đứng tại vị trí số và chụp theo hướng mũi tên. Xanh = đã chụp",
    plan_direction: "Đứng tại vị trí số trên bản vẽ và hướng máy ảnh theo mũi tên.",
    plan_shoot: "Mở máy ảnh",
    dir_0: "Bắc",
    dir_1: "Đông Bắc",
    dir_2: "Đông",
    dir_3: "Đông Nam",
    dir_4: "Nam",
    dir_5: "Tây Nam",
    dir_6: "Tây",
    dir_7: "Tây Bắc",
    facing: "Hướng máy ảnh",
    guide_arrived: "Đã nhận hướng dẫn chụp ảnh",
    video_tap: "Chạm để quay video (tối đa 60 giây)",
    video_too_long: "Video tối đa 60 giây. Vui lòng quay lại ngắn hơn.",
  },
  id: {
    app_name: "NEO Construction Staf",
    login_title: "Login Staf",
    login_id: "ID Login",
    password: "Kata sandi",
    sign_in: "Masuk",
    login_failed: "ID atau kata sandi salah",
    logout: "Keluar",
    home: "Beranda",
    schedule: "Jadwal",
    photos: "Foto",
    today: "Hari ini",
    tomorrow: "Besok",
    notifications: "Pemberitahuan",
    no_plans: "Tidak ada jadwal",
    no_notifications: "Tidak ada pemberitahuan",
    meeting: "Kumpul",
    site_address: "Alamat lokasi",
    safety: "Keselamatan",
    work_content: "Isi pekerjaan",
    instructions: "Instruksi",
    tools_to_bring: "Alat",
    month_schedule: "Jadwal bulanan",
    upload_photo: "Unggah foto",
    select_project: "Pilih proyek",
    select_site: "Pilih lokasi",
    select_schedule: "Pilih jadwal (opsional)",
    category: "Kategori",
    cat_before: "Sebelum",
    cat_during: "Selama",
    cat_after: "Sesudah",
    title_label: "Judul",
    description: "Deskripsi (boleh bahasa Anda)",
    take_or_choose: "Ambil / pilih foto",
    submit: "Kirim",
    uploading: "Mengirim...",
    uploaded_ok: "Foto terkirim",
    upload_failed: "Gagal mengirim",
    my_photos: "Foto saya",
    status_label: "Status",
    st_pending: "Belum dicek",
    st_approved: "Disetujui",
    st_rejected: "Dikembalikan",
    type_work: "Kerja",
    type_off: "Libur",
    type_leave: "Cuti",
    report_title: "Laporan kerja",
    actual_start: "Mulai sebenarnya",
    actual_end: "Selesai sebenarnya",
    report_note: "Laporan / catatan",
    done_label: "Selesai",
    send_report: "Kirim laporan",
    report_sent: "Laporan terkirim",
    language: "Bahasa",
    new_schedule: "Jadwal kerja baru",
    changed_schedule: "Jadwal diubah",
    cancelled_schedule: "Jadwal dibatalkan",
    all_day: "Seharian",
    required_count: "Jumlah orang",
    people: "orang",
    nav_report: "Laporan",
    report_new: "Tulis laporan",
    hours_label: "Jam kerja",
    report_saved: "Laporan tersimpan",
    my_reports: "Riwayat laporan",
    no_reports: "Belum ada laporan",
    date_label: "Tanggal",
    nav_survey: "Survei",
    survey_title: "Survei lokasi",
    survey_none: "Tidak ada proyek yang ditugaskan",
    shot_guide: "Petunjuk foto (ketuk untuk memotret)",
    shot_none: "Belum ada petunjuk. Gunakan \"Foto lain\" di bawah.",
    shot_tap: "Ketuk untuk membuka kamera",
    shot_taken: "Sudah difoto",
    shot_again: "foto lagi",
    shot_required: "Wajib",
    extra_photo: "Foto lain",
    survey_result: "Catat hasil survei",
    survey_note_ph: "Kondisi lokasi, ukuran, perhatian, isi penawaran",
    survey_submit: "Kirim hasil survei",
    survey_saved: "Hasil survei terkirim",
    survey_missing: "Foto wajib belum diambil",
    survey_recorded: "Tercatat",
    plan_hint: "Ketuk nomor untuk membuka kamera. Berdiri di titik nomor dan foto sesuai arah panah. Hijau = selesai",
    plan_direction: "Berdiri di titik bernomor pada denah dan arahkan kamera sesuai arah panah.",
    plan_shoot: "Buka kamera",
    dir_0: "Utara",
    dir_1: "Timur Laut",
    dir_2: "Timur",
    dir_3: "Tenggara",
    dir_4: "Selatan",
    dir_5: "Barat Daya",
    dir_6: "Barat",
    dir_7: "Barat Laut",
    facing: "Arah kamera",
    guide_arrived: "Petunjuk foto diterima",
    video_tap: "Ketuk untuk merekam video (maks. 60 detik)",
    video_too_long: "Video maksimal 60 detik. Silakan rekam ulang lebih singkat.",
  },
};

export function makeT(lang) {
  const dict = T[lang] || T.ja;
  return (key) => dict[key] ?? T.ja[key] ?? key;
}
